<div
  class="soft-ds-date-range-picker-root"
  [class.soft-ds-date-range-picker-root--without-shortcuts]="!showShortcuts()"
  [class.soft-ds-date-range-picker-root--without-week-numbers]="!showWeekNumbers()"
>
  @if (showShortcuts()) {
    <div class="soft-ds-date-range-picker-shortcuts" aria-label="Date range shortcuts">
      @for (shortcut of resolvedShortcuts(); track shortcut.label) {
        <button
          type="button"
          class="soft-ds-date-range-picker-shortcut"
          [class.is-selected]="
            shortcut.resolvedValue.from === selectedValue()?.from &&
            shortcut.resolvedValue.to === selectedValue()?.to
          "
          (click)="onSelectShortcut(shortcut)"
        >
          <span class="soft-ds-date-range-picker-shortcut-label">
            {{ shortcut.label }}
          </span>
          <span class="soft-ds-date-range-picker-shortcut-date">
            {{ formatShortDate(shortcut.resolvedValue.from) }}
            -
            {{ formatShortDate(shortcut.resolvedValue.to) }}
          </span>
        </button>
      }
    </div>
  }

  <div class="soft-ds-date-range-picker-panel">
    <div class="soft-ds-date-range-picker-calendar-shell">
      @defer {
        <soft-date-range-picker-mobiscroll-host
          #mobiscrollHost
          [value]="valueArray()"
          [showWeekNumbers]="showWeekNumbers()"
          [showRangeLabels]="showRangeLabels()"
          [showOuterDays]="showOuterDays()"
          [selectionMode]="selectionMode()"
          [firstSelectDay]="firstSelectDay()"
          [selectSize]="selectSize()"
          [themeVariant]="themeVariant()"
          (valueChange)="onValueChange($event)"
          (pageLoaded)="onCalendarPageLoaded()"
        />
      }
    </div>

    @if (showShortcuts()) {
      <div
        class="soft-ds-date-range-picker-mobile-shortcuts"
        aria-label="Date range shortcuts"
      >
        @for (shortcut of resolvedShortcuts(); track shortcut.label) {
          <button
            type="button"
            class="soft-ds-date-range-picker-mobile-shortcut"
            [class.is-selected]="
              shortcut.resolvedValue.from === selectedValue()?.from &&
              shortcut.resolvedValue.to === selectedValue()?.to
            "
            (click)="onSelectShortcut(shortcut)"
          >
            {{ shortcut.label }}
          </button>
        }
      </div>
    }
  </div>
</div>
